import useCustomDoubtsStore from '@stores/customDoubtsStore';

/* eslint-disable import/prefer-default-export */
export const getSelectedDoubtSolution = (doubtDetails) =>
  doubtDetails?.isSelectedReset
    ? doubtDetails?.solutions?.[0]?.uid
    : useCustomDoubtsStore.getState().selectedDoubtSolution;
